import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import Login from "../pages/Login/Login";
import React from 'react'

const PrivateRoute = ({allowedRoles}) => {
  const location = useLocation();
  const userState = useSelector((state) => state.userReducer);
  const { errorMessage, user, isLogin } = userState;

  console.log("useAuth ", user, isLogin);
  console.log("private router access " , allowedRoles.includes(user.role));
  console.log("allowedRoles ", allowedRoles)
  return isLogin && allowedRoles.includes(user.role) 
  ? 
  <Outlet></Outlet> 
  : user && user.email 
  ? <Navigate to="/unauthorized" />
  :<Navigate to="/login" />; ///state={{from: location}} replace />;
};

export default PrivateRoute;
